import { Link } from 'gatsby';
import { EuiSpacer } from '@elastic/eui';
import InstarVisionCard from 'components/Software/Windows/InstarVision/Image_Adjust/instarVisionCard01';
import NavButtons from 'components/Software/Windows/InstarVision/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  EuiSpacer,
  InstarVisionCard,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};